<template>
  <div :class="['emd-form-group', `js${name}group`]">
    <label :class="['emd-label', required ? 'u-required' : '']">{{title}}</label>
    <div class="emd-select">
      <select
        :name="name"
        :required="required"
        @input="onInput"
        @change="handleInput"
      >
        <option v-for="(val, index) in enumList" :key="index" :value="val" :selected="val === value">{{val}}</option>
      </select>
      <div class="emd-select__arrow"></div>
    </div>
    <div :class="['emd-input-helper', `js${name}helper`]"></div>
  </div>
</template>
<script>
export default {
  name: 'EmdSelect',
  props: ['required', 'name', 'value', 'enumList', 'onInput', 'title'],
  methods: {
    handleInput (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
<style scoped>
</style>
